module.exports = __webpack_public_path__ + "static/media/artunity-mockup-1.0678cbeb.jpg";